import { NodeInstance } from "../types/node.types";
import { TreeNode } from "../types/tree.types";

/**
 * Indents the node using white spaces in the template string.
 * @param param0 White spaces to indent the node.
 * @param node
 * @param isActive
 * @returns
 *
 * @example
 *  const nodes = [
 *     indent`${someNode.create()}`
 *     indent`  ${someChildNode.create()}`
 *  ]
 */
export function indent(
  [indent]: TemplateStringsArray,
  node: NodeInstance,
  isActive = true
): TreeNode {
  return { node, indent: indent.length, isActive };
}
